export const studyFr = {
  common: {
    academy: 'Académie',
    brand: 'Académie Deenly',
    studyRoom: 'Salle d’étude',
    collection: 'Collection',
    map: 'Carte',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    add: 'Ajouter',
    close: 'Fermer',
    search: 'Rechercher…',
    all: 'Tout',
    loading: 'Chargement…',
    rename: 'Renommer',
    name: 'Nom',
    edit: 'Modifier',
    write: 'Écrire',
    fromCollection: 'De la Collection',
    onMap: 'Sur la carte',
    email: 'E-mail',
    password: 'Mot de passe',
    cards: '{n} fiche | {n} fiches',
    pages: '{n} page | {n} pages',
    color: 'Couleur {name}',
    colorColon: 'Couleur : {name}',
    colors: { teal: 'sarcelle', gold: 'or', rose: 'rose', sky: 'bleu ciel', violet: 'violet', slate: 'ardoise', mint: 'menthe', lilac: 'lilas', white: 'blanc' },
  },
  errors: {
    network: 'Pas de connexion au serveur. Vérifie ton internet et réessaie.',
    tooMany: 'Trop de tentatives. Attends une minute, puis réessaie.',
    generic: 'Une erreur s’est produite. Réessaie.',
  },
  cardTypes: {
    quran: { label: 'Coran', short: 'Verset' },
    hadith: { label: 'Sunna', short: 'Hadith' },
    scholar: { label: 'Savants', short: 'Citation' },
    root: { label: 'Racines', short: 'Racine' },
    note: { label: 'Les miennes', short: 'Note' },
  },
  templates: {
    fiqh: {
      label: 'Question de fiqh',
      hint: 'Quel est le jugement sur un sujet : les preuves du Coran et de la Sunna, les avis des savants, ta conclusion.',
      lanes: { question: 'Question', quran: 'Coran', sunnah: 'Sunna', opinions: 'Avis des savants', conclusion: 'Conclusion' },
    },
    tafsir: {
      label: 'Tafsir d’un verset',
      hint: 'Un verset ou un passage : les mots, le contexte de la révélation, ce que disent les exégètes, les enseignements.',
      lanes: { ayah: 'Verset', words: 'Mots et racines', occasion: 'Contexte de la révélation', tafsirs: 'Tafsirs', lessons: 'Enseignements' },
    },
    hadith: {
      label: 'Étude de hadith',
      hint: 'Un hadith : son texte et sa source, le charh, les jugements qui en découlent, les enseignements.',
      lanes: { text: 'Texte et source', sharh: 'Charh', rulings: 'Jugements tirés du hadith', lessons: 'Enseignements' },
    },
    free: {
      label: 'Carte libre',
      hint: 'Une carte vide, sans cadres, pour tout le reste.',
    },
  },
  taskColumns: { todo: 'À faire', doing: 'En cours', done: 'Terminé' },
  card: {
    page: 'p. {page}',
    noteLine: 'Note : {note}',
  },
  due: {
    late: '{n} j de retard',
    today: 'aujourd’hui',
    tomorrow: 'demain',
    in: 'dans {n} j',
  },
  password: {
    length: 'Au moins {n} caractères',
    letters: 'Lettres',
    numbers: 'Chiffres',
    match: 'Les deux mots de passe correspondent',
    failed: 'Une erreur est survenue. Réessaie.',
    offline: 'Pas de connexion au serveur. Vérifie ta connexion et réessaie.',
    tooMany: 'Trop de tentatives. Attends une minute et réessaie.',
    meter: 'Solidité du mot de passe',
    show: 'Afficher le mot de passe',
    hide: 'Masquer le mot de passe',
    caps: 'La touche Verr. Maj est activée',
    privacy: 'Confidentialité',
    strength: ['Trop faible', 'Faible', 'Correct', 'Fort', 'Excellent'],
  },
  auth: {
    panelBadge: 'Panneau Deenly',
    backToSite: 'Vers le site',
    login: {
      metaTitleAcademy: 'Connexion · Académie Deenly',
      metaDescAcademy: 'Connecte-toi et continue d’apprendre à l’Académie Deenly.',
      metaTitle: 'Connexion · Deenly',
      metaDesc: 'Connexion au panneau Deenly.',
      academy: {
        title: 'Bon retour.',
        accent: 'Reprends là où tu t’étais arrêté.',
        lead: 'Tes sujets, tes sources et tes lectures t’attendent.',
        cardTitle: 'Connexion à l’Académie',
      },
      panel: {
        title: 'Bon retour.',
        accent: 'Modifier. Publier. Suivre.',
        lead: 'La bibliothèque, les conférences, le fil et les statistiques de Deenly, au même endroit.',
        cardTitle: 'Connexion au panneau',
      },
      locked: 'Trop de tentatives incorrectes. Par sécurité, la connexion est suspendue. Réessaie dans {time}.',
      errors: {
        credentials: 'L’e-mail ou le mot de passe est incorrect.',
        invalid: 'Saisis une adresse e-mail valide et ton mot de passe.',
        network: 'Pas de connexion au serveur. Vérifie ton internet et réessaie.',
        server: 'La connexion ne fonctionne pas pour le moment. Réessaie dans une minute.',
      },
      notices: {
        reset: 'Ton mot de passe a été modifié. Connecte-toi avec le nouveau.',
        expired: 'Ta session a expiré. Connecte-toi à nouveau.',
      },
      noAccount: 'Pas encore de compte ?',
      createFree: 'Crées-en un gratuitement',
      teamOnly: 'Seuls les membres de l’équipe ont accès. Un administrateur ouvre le compte.',
      forgot: 'Mot de passe oublié ?',
      retryIn: 'Réessaie dans {time}',
      submit: 'Se connecter',
    },
    forgot: {
      metaTitle: 'Mot de passe oublié · Deenly',
      metaDesc: 'Un lien pour un nouveau mot de passe sur ton e-mail.',
      invalidEmail: 'Saisis une adresse e-mail valide.',
      title: 'Mot de passe oublié ?',
      accent: 'Un nouveau en une minute.',
      lead: 'Saisis l’e-mail de ton compte et nous t’enverrons un lien pour un nouveau mot de passe. Le lien est valable 60 minutes.',
      cardSent: 'Vérifie tes e-mails',
      cardLink: 'Lien pour un nouveau mot de passe',
      sentBody: 'Si un compte avec l’adresse {email} existe, nous venons d’envoyer un lien pour un nouveau mot de passe. Le lien est valable 60 minutes et ne fonctionne qu’une seule fois.',
      sentHint: 'Tu ne le vois pas ? Regarde aussi dans les spams, ou demande-en un nouveau dans une minute.',
      resend: 'Renvoyer',
      backToLogin: 'Retour à la connexion',
      send: 'Envoyer le lien',
      remembered: 'Je m’en souviens, retour à la connexion',
    },
    reset: {
      metaTitle: 'Nouveau mot de passe · Deenly',
      metaDesc: 'Définis un nouveau mot de passe pour Deenly.',
      title: 'Nouveau mot de passe.',
      accent: 'Une étape.',
      lead: 'Après le changement, tu seras déconnecté de tous les appareils sur lesquels tu es connecté.',
      cardBroken: 'Le lien est incomplet',
      cardSet: 'Définis un nouveau mot de passe',
      hintBroken: 'Ouvre à nouveau le lien entier depuis l’e-mail, ou demande-en un nouveau.',
      hintAccount: 'Pour le compte {email}',
      requestLink: 'Demander un nouveau lien',
      newPassword: 'Nouveau mot de passe',
      repeat: 'Répète le nouveau mot de passe',
      mismatch: 'Les mots de passe ne correspondent pas.',
      submit: 'Enregistrer le nouveau mot de passe',
    },
  },
  signup: {
    metaTitle: 'Nouveau compte · Académie Deenly',
    metaDesc: 'Un compte gratuit pour l’Académie Deenly : ta place pour étudier l’islam.',
    title: 'Ta place',
    accent: 'pour étudier l’islam.',
    lead: 'Versets, hadiths et notes sur une seule carte, ta khatma et les livres que tu lis, tes obligations à l’université. Gratuit.',
    cardTitle: 'Nouveau compte',
    bullet1: 'Une carte du savoir : versets, hadiths, tafsir et notes au même endroit',
    bullet2: 'Des preuves du Coran et des hadiths, trouvées par le sens',
    bullet3: 'Khatma, livres et obligations avec échéances, chaque jour devant toi',
    haveAccount: 'Tu as déjà un compte ?',
    signIn: 'Se connecter',
    firstName: 'Prénom',
    lastName: 'Nom',
    enterFirstName: 'Saisis ton prénom.',
    enterLastName: 'Saisis ton nom.',
    repeatPassword: 'Répète le mot de passe',
    mismatch: 'Les mots de passe ne correspondent pas.',
    accept: 'J’accepte la {policy}.',
    policy: 'politique de confidentialité',
    confirmTerms: 'Confirme que tu acceptes la politique de confidentialité.',
    submit: 'Créer le compte',
  },
  layout: {
    closeMenu: 'Fermer le menu',
    today: 'Aujourd’hui',
    spaces: 'Espaces',
    newSpace: 'Nouvel espace',
    spacesFailed: 'Les espaces n’ont pas été chargés.',
    logout: 'Déconnexion',
    dialogSubtitle: 'Une matière à l’université ou un objectif personnel : on y trouve tes sujets, tes tâches et tes lectures.',
    subject: 'Matière',
    goal: 'Objectif',
    placeholderGoal: 'p. ex. Ramadan 1448',
    placeholderSubject: 'p. ex. Usul al-fiqh III',
    create: 'Créer l’espace',
    ideas: {
      usul: 'Usul al-fiqh',
      tafsir: 'Tafsir',
      hadith: 'Hadith',
      arabic: 'Arabe',
      ramadan: 'Ramadan',
      khatma: 'Khatma',
      hifz: 'Hifz',
      exam: 'Examen',
    },
  },
  today: {
    metaTitle: 'Aujourd’hui · Salle d’étude · Académie Deenly',
    metaDesc: 'Tes tâches, tes lectures et tes sujets.',
    morning: 'Bonjour',
    day: 'Bonjour',
    evening: 'Bonsoir',
    promptFiqh: 'La question que tu étudies (p. ex. « Les intérêts sont-ils haram ? »)',
    failed: 'Nous n’avons pas pu charger ta Salle d’étude.',
    retry: 'Réessayer',
    weekTasks: 'Tâches de la semaine',
    allTasks: 'Toutes les tâches',
    noTasks: 'Aucune tâche à rendre dans les sept prochains jours.',
    doneAria: 'Terminé : {title}',
    inProgress: 'En cours',
    reading: 'Lecture',
    planTitle: 'Crée un plan de lecture',
    planBody: 'Une khatma d’ici la fin du ramadan, ou un livre pour un examen : tu auras une mesure quotidienne.',
    addReading: 'Ajouter une lecture',
    continue: 'Reprends là où tu t’étais arrêté',
    firstTopic: 'Commence ton premier sujet',
    streak: 'Jours de lecture d’affilée',
    days: 'jour | jours',
    weekAria: 'Cette semaine : {n} page | Cette semaine : {n} pages',
    weekPages: '{n} page cette semaine | {n} pages cette semaine',
    saveTip: 'Tu peux aussi enregistrer un verset en lisant le Coran : le bouton « Enregistrer » sous chaque verset.',
  },
  collection: {
    metaTitle: 'Collection · Salle d’étude · Académie Deenly',
    metaDesc: 'Tes versets, hadiths, citations et notes.',
    subtitle: 'Tout ce que tu enregistres, une seule fois, pour autant de sujets que tu veux.',
    newCard: 'Nouvelle fiche',
    noResults: 'Rien pour cette recherche.',
    empty: 'Ta Collection est vide.',
    emptyBody: 'Enregistre ton premier verset, hadith ou citation d’un livre. Chaque fiche porte sa source, pour que tu puisses la citer plus tard.',
  },
  space: {
    fallback: 'Espace',
    namePrompt: 'Nom de l’espace',
    confirmDelete: 'Supprimer l’espace « {title} » avec tous ses sujets, tâches et lectures ? Les fiches restent dans ta Collection.',
    confirmDeleteTask: 'Supprimer la tâche ?',
    deleteSpace: 'Supprimer l’espace',
    navAria: 'Espace',
    topics: 'Sujets',
    tasks: 'Tâches',
    reading: 'Lecture',
    newTopic: 'Nouveau sujet',
    taskPlaceholder: 'Nouvelle tâche, p. ex. « Examen d’usul »',
    deadline: 'Échéance',
    moveLeft: 'Déplacer à gauche : {title}',
    moveRight: 'Déplacer à droite : {title}',
    khatmaPlan: 'Plan de khatma',
    book: 'Livre',
    readingEmpty: 'Ajoute une khatma ou un livre que tu lis. Si tu fixes une date de fin, tu auras une mesure quotidienne.',
    fiqhLabel: 'La question que tu étudies',
    topicName: 'Nom du sujet',
    placeholderFiqh: 'p. ex. Les intérêts sont-ils haram ?',
    placeholderTafsir: 'p. ex. Ayat al-Kursi (2:255)',
    placeholderHadith: 'p. ex. Le hadith sur les intentions',
    previewFrames: 'La carte commence avec ces cadres',
    previewEmpty: 'Carte vide',
    openMap: 'Ouvrir la carte',
    task: 'Tâche',
    status: 'État',
    topic: 'Sujet',
    noTopic: 'Sans sujet',
    notes: 'Notes',
    openTopic: 'Ouvrir le sujet',
    bookPlaceholder: 'p. ex. Ihya Ulum ad-Din, tome 1',
    khatma: 'Khatma',
    author: 'Auteur',
    pageCount: 'Nombre de pages',
    khatmaInfo: 'La khatma se compte sur les 604 pages du mushaf de Médine ; tu verras aussi dans quel juz tu es.',
    finishBy: 'Je veux terminer avant le',
    optional: '(facultatif)',
    finishHint: 'Avec une date, tu as une mesure quotidienne : combien de pages par jour pour finir à temps.',
  },
  reading: {
    confirmDelete: 'Supprimer « {title} » ?',
    khatmaJuz: 'Khatma · juz {juz}',
    until: 'jusqu’au {date}',
    finished: 'Terminé. Qu’Allah y mette la baraka !',
    measureMet: 'La mesure du jour est atteinte ({n} p.).',
    todayOf: 'Aujourd’hui : {read} sur {target} page. | Aujourd’hui : {read} sur {target} pages.',
    readToday: 'Lu aujourd’hui : {n} p.',
    reachedPage: 'Je suis arrivé à la page',
    pagePlaceholder: 'Page (actuelle : {n})',
    plusPages: '+{n} p.',
  },
  picker: {
    title: 'De ta Collection',
    subtitle: 'Clique sur une fiche pour la placer sur la carte.',
    empty: 'Aucune fiche ici. Ajoute une source directement sur la carte.',
    onMap: 'Sur la carte',
  },
  save: {
    label: 'Enregistrer dans la Salle d’étude',
    saved: 'Enregistré dans la Collection',
  },
  form: {
    confirmDelete: 'Supprimer la fiche de la Collection ? Elle disparaîtra aussi de tous les sujets où elle se trouve.',
    editTitle: 'Modifier la fiche',
    addTitle: 'Ajouter une source',
    intoFrame: 'Dans le cadre « {frame} »',
    toMapAndCollection: 'Sur la carte et dans ta Collection',
    toCollection: 'Dans ta Collection',
    kindAria: 'Type de source',
    findSurah: 'Trouver une sourate',
    surahPlaceholder: 'Sourate : nom ou numéro',
    surahs: 'Sourates',
    ayahCount: '{n} verset | {n} versets',
    noSurah: 'Aucune sourate de ce nom.',
    surah: 'Sourate',
    perCard: '20 au maximum par fiche',
    from: 'De',
    to: 'À',
    loadingAyat: 'Chargement des versets…',
    searchHadiths: 'Rechercher des hadiths',
    hadithPlaceholder: 'Cherche dans la collection Deenly : intentions, intention, riba…',
    hadithNote: 'Pour l’instant, la collection est surtout en anglais. Tu ne trouves pas un hadith ? {link}.',
    hadithManual: 'Saisis-le avec sa source',
    searching: 'Recherche…',
    english: 'anglais',
    noResults: 'Aucun résultat.',
    minLetters: 'Saisis au moins trois lettres.',
    backToSearch: '← Retour à la recherche',
    hadithText: 'Texte du hadith…',
    scholarText: 'Une citation ou un résumé de ce qu’a dit le savant…',
    noteText: 'Ta note…',
    hadithSource: 'Source : recueil et numéro',
    scholarSource: 'Ouvrage et auteur',
    hadithSourcePlaceholder: 'p. ex. Muslim, 1598',
    scholarSourcePlaceholder: 'p. ex. Ibn Qudama, Al-Mughni',
    page: 'Page',
    titleOptional: 'Titre (facultatif)',
    addNote: 'Ajoute ta propre note à la source',
    myNote: 'Ma note',
    notePlaceholder: 'De quoi c’est une preuve, ce qui compte pour toi…',
    addToMap: 'Ajouter sur la carte',
    saveToCollection: 'Enregistrer dans la Collection',
    deleteFromCollection: 'Supprimer de la Collection',
  },
  node: {
    notePlaceholder: 'Écris…',
    noteEmpty: 'Double-clic pour écrire',
    duplicate: 'Dupliquer',
    textPlaceholder: 'Titre…',
    textEmpty: 'Double-clic pour le texte',
    tidyLabel: 'Ranger les fiches',
    tidy: 'Ranger',
    deleteFrame: 'Supprimer le cadre',
    frame: 'Cadre',
    addInto: 'Ajouter à : {title}',
    open: 'Ouvrir',
    removeFromMap: 'Retirer de la carte',
  },
  quick: {
    addToMap: 'Ajouter sur la carte',
    placeholder: 'Verset, racine ou sujet…',
    hint: 'P. ex. 2:255 · al-baqara 255-257 · yasin 1 · رحم · patience',
    rootTitle: 'Racine {root}',
    rootText: 'Les mots de cette racine et le nombre de fois où ils apparaissent dans le Coran.',
    surah: 'Sourate {n}',
    evidence: 'Trouver des preuves',
    evidenceHint: 'Place sur la carte les 3 versets et les 3 hadiths les plus proches, chacun dans son cadre.',
    noResults: 'Rien pour cela. Essaie une référence (2:255) ou un autre mot.',
    enter: 'Entrée : sur la carte',
  },
  explorer: {
    title: 'Explorer',
    tabs: {
      words: 'Mots',
      tafsir: 'Tafsir',
      translations: 'Traductions',
      related: 'Versets',
      hadiths: 'Hadiths',
      sharh: 'Charh',
      lessons: 'Leçons',
      ayat: 'Versets',
    },
    surah: 'Sourate {n}',
    tafsirName: 'Tafsir Al-Mukhtasar',
    tafsirTitle: 'Tafsir Al-Mukhtasar · {ref}',
    tafsirSource: 'Tafsir Al-Mukhtasar, {ref}',
    translationTitle: 'Traduction : {name}',
    translationSource: 'Coran, {ref}, traduction : {name}',
    sharhTitle: 'Charh : {title}',
    sharhSource: 'HadeethEnc.com, explication du hadith',
    lessonTitle: 'Un enseignement du hadith',
    lessonsTitle: 'Enseignements du hadith',
    edge: {
      tafsir: 'tafsir',
      translation: 'traduction',
      root: 'racine',
      rootOf: 'racine {root}',
      hadith: 'hadith',
      sharh: 'charh',
      lesson: 'enseignement',
      lessons: 'enseignements',
      related: 'verset proche',
      ayah: 'verset',
    },
    backToAyah: 'Retour au verset',
    hadithFallback: 'Hadith',
    whatToExplore: 'Ce que tu peux explorer',
    failed: 'Le chargement a échoué. Réessaie.',
    wordsHint: 'Touche un mot pour voir sa racine dans tout le Coran.',
    noTafsir: 'Il n’y a pas encore de tafsir pour ce verset.',
    relatedHint: 'Les versets les plus proches par le sens. Fais-les glisser sur la carte.',
    noRelated: 'Aucun verset proche pour ce verset.',
    hadithsHint: 'Les hadiths les plus proches de ce verset par le sens. Fais-les glisser sur la carte.',
    noHadiths: 'Aucun hadith pour ce verset.',
    explanation: 'Explication du hadith',
    noExplanation: 'Aucune explication pour ce hadith.',
    allLessons: 'Tous les enseignements en une seule note',
    noLessons: 'Aucun enseignement pour ce hadith.',
    ayatHint: 'Les versets les plus proches de ce hadith par le sens.',
    noAyat: 'Aucun verset proche.',
    rootOnMap: 'Racine sur la carte',
    rootStats: '{times} dans {ayahs}, dans {surahs}',
    rootTimes: '{n} fois | {n} fois',
    rootAyahs: '{n} verset | {n} versets',
    rootSurahs: '{n} sourate | {n} sourates',
    previous: 'Précédent',
    next: 'Suivant',
  },
  topic: {
    fallback: 'Sujet',
    newFrame: 'Nouveau cadre',
    added: 'Ajouté sur la carte et dans ta Collection.',
    removedCount: 'Supprimé : {n}.',
    cardRemoved: 'La fiche a été retirée de la carte (elle reste dans ta Collection).',
    removed: 'Supprimé.',
    confirmDelete: 'Supprimer ce sujet et sa carte ? Les fiches restent dans ta Collection.',
    restOfMap: 'Le reste de la carte',
    copied: 'Copié. Colle-le dans Word ou Google Docs.',
    tools: {
      search: 'Trouver et ajouter',
      note: 'Note',
      text: 'Texte',
      frame: 'Cadre',
      ayah: 'Verset',
      hadith: 'Hadith',
      quote: 'Citation d’un savant',
    },
    addHere: 'Ajouter ici',
    edgePlaceholder: 'p. ex. prouve, explique',
    deleteArrow: 'Supprimer la flèche',
    emptyTitle: 'Ta carte est prête.',
    tipSearch: 'Appuie sur / et saisis un verset (2:255, al-baqara 255), une racine ou un sujet.',
    tipExplore: 'Sélectionne un verset sur la carte : ses mots, le tafsir, les traductions et les versets proches s’ouvrent.',
    tipPlus: 'Clique sur ＋ dans un cadre pour y ajouter un verset, un hadith ou une citation.',
    tipDouble: 'Double-clique n’importe où sur la carte pour une note, du texte ou un nouveau cadre.',
    tipArrow: 'Tire depuis le point au bord d’une fiche vers une autre : tu obtiens une flèche.',
    copyAsText: 'Copier en texte',
    emptyDoc: 'La carte est encore vide.',
    back: 'Retour',
    document: 'Document',
    presentTitle: 'Présenter les cadres comme des diapositives',
    present: 'Présenter',
    deleteTopic: 'Supprimer le sujet',
    toolsAria: 'Outils',
    zoomOut: 'Réduire',
    zoomIn: 'Agrandir',
    fitAll: 'Tout afficher',
    zoomHint: 'Double-clic : ajouter · Maj + glisser : sélectionner plusieurs · Suppr : supprimer',
    presentationAria: 'Présentation',
    prevFrame: 'Cadre précédent',
    nextFrame: 'Cadre suivant',
    finish: 'Terminer',
    undo: 'Annuler',
    myNote: 'Ma note',
    wordByWord: 'Mot à mot',
    tafsir: 'Tafsir',
    link: 'Lien',
  },
};
